
import { getOrderRecord } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { dateTimeFormatter, formatNum } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    },
    formatNum(value: string) {
      return formatNum(value);
    }
  }
})
export default class extends Vue {
  menus: any[] = [
    {
      title: '提交记录',
      isOpen: true,
      child: [
        {
          id: 1,
          title: '代打印',
          link: '/user',
          name: 'user'
        },
        {
          id: 11,
          title: '耗材定制',
          link: '/coupon',
          name: 'coupon'
        }
      ]
    }
  ]

  name: string = ''

  orderList: any[] = []

  // 当前页数
  currentpage: number = 1

  pageNo: number = 1

  pageSize: number = 10

  currentIndex: number = Number(this.$route.query.currentIndex)

  // 有无数据
  isNodata: boolean = false

  // 总条数
  totalnumber: number = 10

  created() {
    this.getData();
  }

  async getData() {
    const res: any = await getOrderRecord({
      showType: this.currentIndex,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: 1
    });
    this.orderList = res.data.data.list;
    this.isNodata = this.orderList.length === 0;
    this.totalnumber = res.data.data.total;
  }

  // 到详情
  goDetails(id: number) {
    this.$router.push(
      `/consumables-orderdetails?id=${id}&showType=${this.currentIndex}`
    );
  }

  handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getData();
    window.scrollTo(0, 0);
  }

  handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getData();
    window.scrollTo(0, 0);
  }

  private changeChild(index: number) {
    this.currentIndex = index;
    this.pageNo = 1;
    this.pageSize = 10;
    this.currentpage = 1;
    this.getData();
  }
}
